<template>
  <div
    class="d-flex flex-column justify-center align-center activeNotifications mx-30"
  >
    <div class="text-center notification-alignment">
      <img
        :src="require('@/assets/img/icons/icon.png')"
        width="60"
        height="auto"
        class="mx-auto"
      />
      <div class="pt-8"></div>
      <div class="text-h5 text-center font-weight-bold">¡¡Enhorabuena!!</div>
      <div class="pt-8"></div>

      <img
        :src="require('@/assets/img/confetti.png')"
        width="90"
        height="auto"
        class="mx-auto"
      />
      <div class="pt-6"></div>
      <div
        class="d-flex flex-column justify-center"
        style="margin: 0 auto; max-width:260px"
      >
        <p class="text-left">
          No hay nada peor que perderse una buena celebración...
        </p>
        <p class="font-weight-bold text-left">Evítalo pulsando aquí</p>
      </div>
      <v-btn
        depressed
        elevation="1"
        color="primary"
        large
        @click="activeNotifications"
        >Activar notificaciones</v-btn
      >
    </div>
    <v-btn text class="primary--text lowercase" @click="next"
      >Las activaré en otro momento</v-btn
    >
  </div>
</template>

<style></style>

<script>
// import * as Sentry from '@sentry/vue'
import { configPushNotifications } from '@/utils/ReactNative'
import { mapActions, mapGetters } from 'vuex'
// import { browserLog } from '../helper/helper'
export default {
  name: 'ActiveConnection',
  computed: {
    ...mapGetters(['getActiveNav'])
  },
  props: {
    activeNav: Object
  },
  methods: {
    ...mapActions({
      activeNotifAction: 'ACTIVE_NOTIF_VIEW',
      saveDeviceAction: 'DEVICE_ACTION'
    }),
    next () {
      const details = {
        action: 'PushNotifPermission',
        params: { pushNotifUpdate: true }
      }
      this.saveDeviceAction(details)
      this.$emit('cancelAlert')
      this.activeNotifAction(true)
    },
    activeNotifications () {
      configPushNotifications().then(() => {
        this.activeNotifAction(false)
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/ActiveNotification.vue